import { mapToCanActivate, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import {
   ContentShellComponent,
   CourseLibraryComponent,
   DashboardComponent,
   LearningJourneysComponent,
   ProgressComponent,
   ResourcesComponent,
   SocialsComponent,
   VideoLibraryComponent
} from '@appContent/containers'
import { ComponentType_ } from '@appShared/services/lookup/[CodeGen]'
import { AuthGuardService, CanActivateGuardService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

const contentRoutes = SITE_DIRECTORY_ROUTES.content

const childAccountRoutes: Routes = [
   {
      path: '',
      component: DashboardComponent,
   },
   {
      path: `${contentRoutes.learningJourneys.baseUri}/:parentContainerId/:title`,
      component: CourseLibraryComponent,
      data: {
         componentTypeCode: ComponentType_.CourseLibrary
      }
   },
   {
      path: `${contentRoutes.learningJourneys.baseUri}/:parentContainerId`,
      component: CourseLibraryComponent,
      data: {
         componentTypeCode: ComponentType_.CourseLibrary
      }
   },
   {
      path: contentRoutes.learningJourneys.baseUri,
      component: LearningJourneysComponent
   },
   {
      path: contentRoutes.progress.baseUri,
      component: ProgressComponent
   },
   {
      path: contentRoutes.quickLinks.baseUri,
      component: ResourcesComponent
   },
   {
      path: contentRoutes.socials.baseUri,
      component: SocialsComponent
   },
   {
      path: contentRoutes.videoLibrary.baseUri,
      component: VideoLibraryComponent
   }
]

export const CONTENT_ROUTES: Routes = [
   {
      path: contentRoutes.baseUri, /* If not lazy-loading contentRoutes.baseUri, else '' */
      component: ContentShellComponent,
      canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService], /* remove if lazy-loading */
      children: childAccountRoutes
   }
]
